import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import InsightsPostsPerformancePDFReportRoute from 'app/modules/public/modules/pdfReports/modules/insightsPostsPerformance';
import routeConfig from 'app/config/routes';
import InsightsCompetitionAnalysisPDFReportRoute from 'app/modules/public/modules/pdfReports/modules/InsightsCompetitionAnalysis';
import { publicPagePerformancePDFReportsRouter } from 'app/modules/public/modules/pdfReports/modules/insightsPagePerformance';
import CustomReportRoute from 'app/modules/public/modules/pdfReports/modules/customReport';
import InsightsLitePDFReportRoute from 'app/modules/public/modules/pdfReports/modules/insightsLite';
import PdfPageStyle from 'app/modules/public/components/PdfPageStyle';

export const publicPDFReportsRouter: RouteObject = {
  path: routeConfig.public.routes.pdfReports.path,
  element: (
    <PdfPageStyle>
      <Outlet />
    </PdfPageStyle>
  ),
  children: [
    {
      index: true,
      element: (
        <Navigate
          to={
            routeConfig.public.routes.pdfReports.routes.insightsPostsPerformance
              .path
          }
        />
      ),
    },
    {
      path: routeConfig.public.routes.pdfReports.routes.insightsPostsPerformance
        .path,
      element: <InsightsPostsPerformancePDFReportRoute />,
    },
    {
      path: routeConfig.public.routes.pdfReports.routes
        .insightsCompetitionAnalysis.path,
      element: <InsightsCompetitionAnalysisPDFReportRoute />,
    },
    {
      path: routeConfig.public.routes.pdfReports.routes.insightsLite.path,
      element: <InsightsLitePDFReportRoute />,
    },
    publicPagePerformancePDFReportsRouter,
    {
      path: routeConfig.public.routes.pdfReports.routes.reports.path,
      element: <CustomReportRoute />,
    },
  ],
};
